import React, { useCallback, useEffect, useState } from 'react'
import styled from 'styled-components'
import NFTMyWalletOnSale from './NFTMyWalletOnSale'
import {
  getAccountCollectionNFTItems,
  getAccountHistory,
  getAccountOnSaleNFTItems
} from '../../../../../services/NFTMarketPlace/Graphquery'
import INFTSalesList from '../../../models/INFTSalesList'
import { INFTWallet } from '../../../models/INFTProfile'
import { ProfileTabState } from '../../../models/IProfileMenu'
import NFTProfileTabMenu from '../NFTProfileTabMenu'
import CollectionList from '../../../data/NFTCollectionsList'
import INFTCollections from '../../../models/INFTCollections'
import { INFTCollectionItems } from '../../../models/INFTCollectionItems'
import NFTWalletCard from '../../../components/NFTWalletCard'
import {
  useGetYetiswapMarketCommissionRateNonYTS,
  useGetYetiswapMarketCommissionRateYTS
} from '../../../../../hooks/useNFTMarketPlace'
import { INFTHistoryData } from '../../../models/INFTHistory'
import NFTHistory from '../History/NFTHistory'

const MyNFTWallet = styled.div`
  width: 100%;
`

const NFTCollectionList = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;

  .nft-card-view {
    margin-right: 0.5rem;

    &:nth-child(4n) {
      margin-right: 0;
    }
  }
`

export default function NFTMyWallet(props: INFTWallet) {
  const [onSaleList, setOnSaleList] = useState<INFTSalesList[]>([])
  const [onCollectionList, setCollectionList] = useState<INFTCollectionItems[]>([])
  const [onHistoryList, setHistoryList] = useState<INFTHistoryData>({ data: [], count: 0 })
  const yetiswapMarketCommissionRateYTS = useGetYetiswapMarketCommissionRateYTS()
  const yetiswapMarketCommissionRateNonYTS = useGetYetiswapMarketCommissionRateNonYTS()
  const { userAccount, match } = props
  const { accountParam } = match.params

  const searchParam = new URLSearchParams(props.location.search).get('tab')
  const activeTab = searchParam ? searchParam : 'on-sale'

  const getSalesNFTItems = useCallback(() => {
    getAccountOnSaleNFTItems(userAccount ? userAccount : '').then((response: INFTSalesList[] | null) => {
      if (response) {
        setOnSaleList(response)
      }
    })
  }, [userAccount])

  const getCollectionNFTItems = useCallback(() => {
    getAccountCollectionNFTItems(
      userAccount ? userAccount : '',
      CollectionList.map((item: INFTCollections) => `"${item.tokenAddress.toLowerCase()}"`)
    ).then((response: INFTCollectionItems[] | null) => {
      if (response) {
        setCollectionList(response)
      }
    })
  }, [userAccount])

  const getUserAccountHistory = useCallback(
    (type: string, skip: number) => {
      getAccountHistory(userAccount ? userAccount : '', type, skip).then((response: INFTHistoryData | null) => {
        if (response) {
          setHistoryList(response)
        }
      })
    },
    [userAccount]
  )

  const getNFTList = useCallback(() => {
    if (userAccount !== '') {
      getSalesNFTItems()
      getCollectionNFTItems()
      getUserAccountHistory('All', 0)
    }
  }, [getSalesNFTItems, getCollectionNFTItems, getUserAccountHistory, userAccount])

  useEffect(() => {
    if (userAccount !== '') {
      getNFTList()
    }
  }, [getNFTList, userAccount])

  function getActive() {
    switch (activeTab) {
      case ProfileTabState.ON_SALE:
        return <NFTMyWalletOnSale account={userAccount} getSalesNFTItems={getNFTList} onSaleList={onSaleList} />
      case ProfileTabState.COLLECTION:
        return (
          <NFTCollectionList>
            {onCollectionList
              .filter((item: INFTCollectionItems) => item)
              .map((item: INFTCollectionItems, index: number) => (
                <NFTWalletCard
                  key={`${index}_WALLET_CARD_${item.tokenID}`}
                  contractAddress={item.contract.id}
                  getSalesNFTItems={getNFTList}
                  account={userAccount}
                  tokenId={+item.tokenID}
                  owner={item.owner.id}
                  yetiswapMarketCommissionRateYTS={yetiswapMarketCommissionRateYTS}
                  yetiswapMarketCommissionRateNonYTS={yetiswapMarketCommissionRateNonYTS}
                />
              ))}
          </NFTCollectionList>
        )
      case ProfileTabState.ACTIVITY:
        return <NFTHistory historyData={onHistoryList} getUserAccountHistory={getUserAccountHistory} />
      default:
        return <React.Fragment />
    }
  }

  return (
    <MyNFTWallet>
      <NFTProfileTabMenu
        account={accountParam}
        activeTab={activeTab}
        onSaleList={onSaleList}
        onCollectionList={onCollectionList}
      />
      {getActive()}
    </MyNFTWallet>
  )
}
